import React from "react";
import Tooltip from "../../Tooltip/Tooltip";
import { Typography } from "../../Typography";
import { ProgressBarProps } from "./types";

type ProgressBarLabelProps = {
    text: string;
    label: ProgressBarProps["label"];
    labelColor: ProgressBarProps["labelColor"];
    labelSize: ProgressBarProps["labelSize"];
    children: React.ReactChild;
};

/**
 * @internal
 */
const ProgressBarLabel: React.FC<ProgressBarLabelProps> = ({ text, label, labelColor, labelSize, children }) => {
    if (label === "right" || label === "bottom" || label === "top") {
        return (
            <>
                {children}
                <Typography
                    as="span"
                    variant={labelSize}
                    color={labelColor}
                    styles={{ transition: "color 150ms ease-in-out" }}
                >
                    {text}
                </Typography>
            </>
        );
    }
    if (label === "tooltip-bottom" || label === "tooltip-top") {
        return (
            <Tooltip delayDuration={300} tooltip={text} tooltipSide={label === "tooltip-top" ? "top" : "bottom"}>
                {children}
            </Tooltip>
        );
    }

    return children as ReturnType<React.FC>;
};

ProgressBarLabel.displayName = "ProgressBarLabel";

export default ProgressBarLabel;
